<mat-drawer-container [hasBackdrop]="true" class="flex-fill">
  <mat-drawer mode="over" [opened]="drawer.isOpen$ | async" (openedChange)="onOpenedChange($event)">
    <kd-drawer></kd-drawer>
  </mat-drawer>
  <mat-drawer-content class="full-fill flex-fill">
    <ng-content></ng-content>
  </mat-drawer-content>
</mat-drawer-container>
